import styled from 'styled-components';

import { GenericDiv } from '../../../../common/Styles';

export const BenefitWrapper = styled(GenericDiv)`
	padding: 120px 0 85px;
	background: #0B1A2F;
	position: relative;
	overflow: hidden;
`;

export const BenefitWrap = styled(GenericDiv)(
	({ theme: { down, breakpoints } }) => `
	color: #fff;
	width: 32%;
	color: #fff;
	box-shadow: 30px 30px 30px 5px rgb(0 0 0 / 25%);
	border-radius: 5px;
	background: #152235;
	min-width: 275px;
	.feature-head {
		padding: 24px 28px 0;
	}
	${down(breakpoints.tb)} {
		margin-right: 10px;
		margin-bottom: 0;
	}
  `
);

export const ImageSec = styled.img(
	({ theme: { down, breakpoints } }) => `
	min-height: 255px;
	${down(breakpoints.tb)} {
		min-height: 100px;
	}
  `
);

export const Listing = styled.ul(
	({ theme: { down, breakpoints } }) => `
	margin-top: 20px;
	padding: 0 28px 34px;
	li {
		position: relative;
		padding-left: 20px;
		font-size: 1.285rem;
		margin-bottom: 20px;
		&:before {
			content:'';
			height: 6px;
			width: 6px;
			background-color: #F76162;
			border-radius: 50%;
			display: inline-block;
			margin-right: 15px;
			margin-top: 8px;
			position: absolute;
			left: 0
		}
		${down(breakpoints.tb)} {
			font-size: 12px;
			margin-top: 0;
		}
	}
  `
);

export const BenefitCurveWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `
      height: 65%;
      width: 100%;
      position: absolute;
      left: 0%;
      top: -58%;
      overflow: hidden;
      ${down(breakpoints.tb)} {
        height:65%;
      }
      `
);

export const BenefitsCurve = styled.div(
	({ theme: { down, breakpoints } }) => `
		height: 100%;
		background: #fff;
		border-radius: 50% / 150px;

		position: absolute;
		left: 50%;
		top: 0%;
		bottom: 0;
		width: calc(100% * 1.4);
		transform: translateX(-50%);
		bottom: 0;
		${down(breakpoints.tb)} {
			width: calc(100% * 1.7);
		}
		`
);
